module.exports = __webpack_public_path__ + "img/11.ef412ade.png";